import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import { Box, IconButton, SvgIcon, Typography } from "@mui/material";
import { type FC } from "react";
import { useFlag } from "../../server/optimizely";
import { useDialog } from "../../utils/hooks/use-dialog";
import { TagsDialog } from "./tags-dialog";

export const TagsFilter: FC = () => {
  const [manage_tags] = useFlag("manage_tags");
  const { open, handleOpen, handleClose } = useDialog();

  return (
    <>
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 1 }}>
        <Typography fontWeight={700} variant="body1">
          Tags
        </Typography>
        {manage_tags && (
          <IconButton data-analytics-id="tags-settings" onClick={handleOpen} size="small">
            <SvgIcon data-testid="settings-menu-chevron" fontSize="small">
              <SettingsOutlined />
            </SvgIcon>
          </IconButton>
        )}
      </Box>
      <TagsDialog open={open} handleClose={handleClose} />
    </>
  );
};
